<template>
  <div v-if='handledHtml' id='article' class='text-inner-html' v-html='handledHtml'></div>
</template>
<script>
import { loadScript, loadStyle, hasVariable } from 'utils'

export default {
  props: {
    html: {
      default: '',
    },
  },
  data () {
    return {
      handledHtml: null,
      index: 0,
    }
  },
  methods: {
    initLazyload () {
      hasVariable('LazyLoad').then(() => {
        new LazyLoad({
          // container: document.querySelector('#article'),
          elements_selector: 'img[data-src]',
          data_src: 'src',
          threshold: 0,
          class_loading: 'lazyloading',
          class_loaded: 'lazyed',
          class_error: 'lazyerror',
          callback_load: (e) => {
            const ele = e.parentNode.querySelector('.lazyload-holder')
            ele && ele.remove()
          },
        })
      })
    },
    videoHtmlHandle () {
      let processHtml = this.handledHtml.replace(/<div class="plvideo"/g, '<video class="plvideo" preload="auto" playsinline webkit-playinline x5-playinline')
      const reg = /<\/script>(.|\n|\r){0,2}<\/div>/ig
      return processHtml.replace(reg, (tag) => {
        return tag.replace('</div>', '</video>')
      })
    },
  },
  mounted () {
    this.handledHtml = lazyHandle.call(this)
    if (!window.LazyLoad) {
      loadScript('https://static.baobaobooks.net/misc/lazyload4.min.js')
    }
    this.$nextTick().then(() => {
      this.initLazyload()
      generateAudio.call(this)
    })
    if (hasVideo.call(this)) {
      this.handledHtml = this.videoHtmlHandle()
      initQcVideo().then(() => {
        loadScriptHandle.call(this)
      })
    }
  },
  beforeDestroy () {
    this.handledHtml = null
  },
}

let imageList = []
function lazyHandle () {
  const reg = /<img([\w\W]+?)\/>/ig
  let newHtml = this.html.replace(reg, (tag) => {
    let width, height, ratio, split
    split = tag.split('?w=').length > 1 ? tag.split('w=')[1] : null
    if (split) {
      width = split.slice(0, split.indexOf('&'))
      split = tag.split('h=').length > 1 ? tag.split('h=')[1] : null
      height = split.slice(0, split.indexOf('"'))
      ratio = height / width
    }
    let widthInfo = ''
    if (width) {
      if (window.innerWidth > 750) {
        widthInfo = `width="750" height="${height}" `
      } else {
        widthInfo = `width="${window.innerWidth - 36}" height="${(window.innerWidth - 36) * ratio}" `
      }
    }
    imageList.push(extraImage(tag))
    // suport lazyload
    if (width) {
      tag = tag.replace('"lazyload"', `"lazyload" ${widthInfo} `)
      return `<div class='re'>${tag}<span class='lazyload-holder'></span></div>`
    } else {
      tag = tag.replace('class="', 'class="lazyload ').replace('src', `class="lazyload" src="//oss.baobaobooks.net/misc/placeholder_spot.png" data-src`)
      return tag
    }
  })
  newHtml = newHtml.replace(/></g, '> <')
  return newHtml
}
function hasVideo () {
  if (!this.handledHtml) return false
  let arr = this.handledHtml.split('<\/script>')
  for (let i = 0; i < arr.length; i++) {
    let result = arr[i].match(/<script type=.+>(.+)/)
    if (result) {
      return true
    }
  }
  return false
}
function loadScriptHandle () {
  if (!this.handledHtml) return
  let arr = this.handledHtml.split('<\/script>')
  for (let i = 0; i < arr.length; i++) {
    let result = arr[i].match(/<script type=.+>(.+)/)
    if (result) {
      let script = document.createElement('script')
      let scriptRaw = result[1].replace('new qcVideo.Player', 'TCPlayer').replace('"auto_play":"0"', 'controlBar: {playbackRateMenuButton: false,volumePanel: false}')
        .replace('file_id', 'fileID').replace('app_id', 'appID')
        .replace(/,"width":\d+,"height":\d+/, '')
      script.innerHTML = scriptRaw
      if (this.isNormal) {
        document.getElementById('article').appendChild(script)
      } else {
        document.getElementById('article' + this.index).appendChild(script)
      }
    }
  }
}
function initQcVideo () {
  if (window.qcVideo) {
    return Promise.resolve()
  }
  loadStyle('https://static.baobaobooks.net/static/js/tcplayer/tcplayer2.css')
  return loadScript('https://static.baobaobooks.net/static/js/tcplayer/tcplayer.min.js')
}
function generateAudio () {
  let ele = document.querySelectorAll('.audio-area')
  if (!this.isNormal) {
    ele = document.querySelectorAll(`#article${this.index}  .audio-area`)
  }
  Array.from(ele).map(item => {
    const title = item.querySelector('.audio-info-area').innerText
    const url = item.dataset.url
    this.$audio.create({
      container: item,
      title,
      url,
    })
  })
}
function extraImage (text) {
  const extraImageSrc = /<img.*?src="(.*?)"/
  let extra = extraImageSrc.exec(text)[1]
  if (extra.indexOf('http') != 0) {
    extra = 'https:' + extra
  }
  return extra.split('?')[0]
}
</script>
